// extracted by mini-css-extract-plugin
module.exports = {"wardDrillDown":"wardDrillDown","-prefecture":"-prefecture","-city":"-city","-ward":"-ward"};